import { Box, Divider, type SxProps, type Theme } from '@mui/material';
import React from 'react';

import useScreenSize from '../../../../utils/useScreenSize';

interface SingleSearchResultContainerProps {
	children: React.ReactNode;
	dividerSx?: SxProps<Theme>;
	isLastElement?: boolean;
}

const SingleSearchResultContainer = ({
	children,
	dividerSx,
	isLastElement,
}: SingleSearchResultContainerProps) => {
	const { isXsScreen } = useScreenSize();
	return (
		<React.Fragment>
			{children}
			{isXsScreen && !isLastElement && (
				<Box sx={{ position: 'relative', ...dividerSx }}>
					<Divider
						component="div"
						sx={{
							minWidth: 'min(100%, 743px)',
							position: 'absolute',
							left: 0,
						}}
					/>
				</Box>
			)}
		</React.Fragment>
	);
};

export default SingleSearchResultContainer;
